export const scenes = [
  {
    id: 'scene 1',
    title: 'scene 1',
    description: "Grandmother's house attic",
    shots: [
      {
        id: 'scene 1-shot-1',
        key: 'shot 1',
        title: "Grandmother's Attic Discovery",
        location: "Interior - Grandmother's house attic",
        scenery:
          'The dimly lit attic is cluttered with old furniture and boxes, dust motes dance in the beams of light filtering through a small window.',
        shot_direction:
          'The Lila, a young woman with curly brown hair, crouches beside a dusty old chest. She carefully opens it, eyes widening as she discovers a rusted, heart-shaped key inside.',
        dialogue: {
          __character1__: 'Wow, what could this unlock?'
        },
        characters: ['character1'],
        isGenerating: false,
        progress: 100,
        prompt:
          'The Lila, a young woman with curly brown hair, crouches beside a dusty old chest. She carefully opens it, eyes widening as she discovers a rusted, heart-shaped key inside.',
        imageSrc:
          'https://dnznrvs05pmza.cloudfront.net/426dbc87-eb54-4190-add5-07f53f99d4f6.png?_jwt=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJrZXlIYXNoIjoiMTBlZTYwYWRlZmExZThiYiIsImJ1Y2tldCI6InJ1bndheS10YXNrLWFydGlmYWN0cyIsInN0YWdlIjoicHJvZCIsImV4cCI6MTc0OTI1NDQwMH0.QhxPCklxnEzKnJdI3xDvH4WreXFHwqiD9cQXp4mavuk'
      },
      {
        id: 'scene 1-shot-2',
        key: 'shot 2',
        title: 'Dream of the Hidden Door',
        location: "Interior - __character1__'s bedroom",
        scenery:
          'The room is dark, moonlight casting soft shadows. The Narrator is asleep, the key resting on the bedside table.',
        shot_direction:
          'The Lila shifts in her sleep, a serene expression on her face. The key glints faintly in the moonlight.',
        dialogue: {},
        characters: [],
        isGenerating: false,
        progress: 100,
        prompt:
          'The Lila shifts in her sleep, a serene expression on her face. The key glints faintly in the moonlight.',
        imageSrc:
          'https://dnznrvs05pmza.cloudfront.net/5788dccf-2612-4aee-9951-16f3411ee586.png?_jwt=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJrZXlIYXNoIjoiYjQ3MWM2ZTA2NGQ5MWI2YiIsImJ1Y2tldCI6InJ1bndheS10YXNrLWFydGlmYWN0cyIsInN0YWdlIjoicHJvZCIsImV4cCI6MTc0OTI1NDQwMH0.re4bu6bxg-EIav2a_amebt2YOBFuvI-OljyAdPQoEpM'
      }
    ]
  },
  {
    id: 'scene 2',
    title: 'scene 2',
    description: "Woods near grandmother's house",
    shots: [
      {
        id: 'scene 2-shot-1',
        key: 'shot 3',
        title: 'Dawn Venture into the Woods',
        location: "Exterior - Woods near grandmother's house",
        scenery:
          'Early morning light filters through the dense canopy, mist clings to the forest floor. The air is crisp and filled with the scent of pine.',
        shot_direction:
          'The Lila, now alert and determined, walks through the woods, her breath visible in the cold air. She clutches the key tightly in her hand.',
        dialogue: {
          __character1__: "I know it's out here somewhere..."
        },
        characters: ['character1'],
        isGenerating: false,
        progress: 100,
        prompt:
          'The Lila, now alert and determined, walks through the woods, her breath visible in the cold air. She clutches the key tightly in her hand.',
        imageSrc:
          'https://dnznrvs05pmza.cloudfront.net/0634f771-62bf-4b09-9da0-faee04d55510.png?_jwt=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJrZXlIYXNoIjoiN2ZkODcwMzdhMzg0MTNlYyIsImJ1Y2tldCI6InJ1bndheS10YXNrLWFydGlmYWN0cyIsInN0YWdlIjoicHJvZCIsImV4cCI6MTc0OTI1NDQwMH0.4mkdm_Y6lTa_pIS0M5HNOcWtFOdoOs71z6IF1s9lcDk'
      },
      {
        id: 'scene 2-shot-2',
        key: 'shot 4',
        title: 'Discovery of the Tree Door',
        location: 'Exterior - Ancient tree in the woods',
        scenery:
          "The massive tree stands tall, its bark gnarled and ancient. A door is carved into its trunk, almost blending with the tree's natural patterns.",
        shot_direction:
          'The Lila approaches the tree, her eyes wide with awe. Her hands tremble as she inserts the key into the lock, anticipation written all over her face.',
        dialogue: {
          __character1__: 'This has to be it.'
        },
        characters: ['character1'],
        isGenerating: false,
        progress: 100,
        prompt:
          'The Lila approaches the tree, her eyes wide with awe. Her hands tremble as she inserts the key into the lock, anticipation written all over her face.',
        imageSrc:
          'https://dnznrvs05pmza.cloudfront.net/2b3c7bac-bc7d-4ef9-be43-ae1ebc141e9b.png?_jwt=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJrZXlIYXNoIjoiMTljODMzMzNjYTEyNmQwZiIsImJ1Y2tldCI6InJ1bndheS10YXNrLWFydGlmYWN0cyIsInN0YWdlIjoicHJvZCIsImV4cCI6MTc0OTI1NDQwMH0.QRWqy9uz8PYsfKRy1lm20hN0rXmlnzQ8OkLKMBwDasM'
      }
    ]
  },
  {
    id: 'scene 3',
    title: 'scene 3',
    description: 'Enchanted realm',
    shots: [
      {
        id: 'scene 3-shot-1',
        key: 'shot 5',
        title: 'Entering the Enchanted World',
        location: 'Interior - Enchanted realm',
        scenery:
          'A vibrant, lush landscape full of extraordinary colors and mystical creatures with sapphire eyes. The atmosphere is magical and alive.',
        shot_direction:
          'The door swings open, revealing a world of vivid colors. The Lila steps inside, eyes reflecting the wonder of the scene before her. Creatures emerge from the foliage, their sapphire eyes shining as they approach her warmly.',
        dialogue: {},
        characters: [],
        isGenerating: false,
        progress: 100,
        prompt:
          'The door swings open, revealing a world of vivid colors. The Lila steps inside, eyes reflecting the wonder of the scene before her. Creatures emerge from the foliage, their sapphire eyes shining as they approach her warmly.',
        imageSrc:
          'https://dnznrvs05pmza.cloudfront.net/9dc75778-bab5-4fdf-b45d-db35ee992745.png?_jwt=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJrZXlIYXNoIjoiOTYwNDkxMjAwZjM0NTM4ZCIsImJ1Y2tldCI6InJ1bndheS10YXNrLWFydGlmYWN0cyIsInN0YWdlIjoicHJvZCIsImV4cCI6MTc0OTI1NDQwMH0.zkScdbxcAhSOdiXB8VRK6-YJtMc4sesdruSYpj7Hc0s'
      },
      {
        id: 'scene 3-shot-2',
        key: 'shot 6',
        title: 'Exploration and Connection',
        location: 'Interior - Various locations in the enchanted realm',
        scenery:
          'The landscape is diverse, from sparkling waterfalls to meadows of colorful flowers. The sun casts a golden glow over everything.',
        shot_direction:
          'The Lila runs through the meadows, laughing with the creatures. They play together, her movements graceful and free. Time seems to slip away unnoticed.',
        dialogue: {},
        characters: [],
        isGenerating: false,
        progress: 100,
        prompt:
          'The Lila runs through the meadows, laughing with the creatures. They play together, her movements graceful and free. Time seems to slip away unnoticed.',
        imageSrc:
          'https://dnznrvs05pmza.cloudfront.net/1264dae3-a61e-4c90-b451-f5a489d1b8b9.png?_jwt=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJrZXlIYXNoIjoiMGQ1NDI3NDk3ODIyODFlYiIsImJ1Y2tldCI6InJ1bndheS10YXNrLWFydGlmYWN0cyIsInN0YWdlIjoicHJvZCIsImV4cCI6MTc0OTI1NDQwMH0.9VM24L3-4ervKLwtoZUdlCFK31992SjWX6xL5wQe-e4'
      }
    ]
  },
  {
    id: 'scene 4',
    title: 'scene 4',
    description: 'Doorway of the ancient tree',
    shots: [
      {
        id: 'scene 4-shot-1',
        key: 'shot 7',
        title: 'Realization and Return',
        location: 'Exterior - Doorway of the ancient tree',
        scenery:
          'The sun sets, casting long shadows across the enchanted realm. The doorway stands open, a gentle breeze rustling the leaves.',
        shot_direction:
          'The Lila stands at the threshold, a mix of joy and sadness in her expression. She touches the key hanging around her neck, feeling its warmth. Reluctantly, she steps back through the door.',
        dialogue: {
          __character1__: "I promise I'll return..."
        },
        characters: ['character1'],
        isGenerating: false,
        progress: 100,
        prompt:
          'The Lila stands at the threshold, a mix of joy and sadness in her expression. She touches the key hanging around her neck, feeling its warmth. Reluctantly, she steps back through the door.',
        imageSrc:
          'https://dnznrvs05pmza.cloudfront.net/29a10e09-b8a9-4d63-a162-029091f13a7b.png?_jwt=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJrZXlIYXNoIjoiZTBkMTQ2MGVlZWNmODY0NCIsImJ1Y2tldCI6InJ1bndheS10YXNrLWFydGlmYWN0cyIsInN0YWdlIjoicHJvZCIsImV4cCI6MTc0OTI1NDQwMH0.5CRDnOnWlWtju7WSfHFWiYUDq0_GhqXdm4eCz_9JRVc'
      }
    ]
  },
  {
    id: 'scene 5',
    title: 'scene 5',
    description: "Woods and grandmother's house",
    shots: [
      {
        id: 'scene 5-shot-1',
        key: 'shot 8',
        title: 'Changed World',
        location: "Exterior - Woods and grandmother's house",
        scenery:
          'The woods seem taller, more overgrown. The house is different, unfamiliar people move about the property.',
        shot_direction:
          'The Lila emerges from the woods, looking around in confusion. Her eyes widen as she takes in the unfamiliar surroundings, her grip on the key tightens.',
        dialogue: {},
        characters: [],
        isGenerating: false,
        progress: 100,
        prompt:
          'The Lila emerges from the woods, looking around in confusion. Her eyes widen as she takes in the unfamiliar surroundings, her grip on the key tightens.',
        imageSrc:
          'https://dnznrvs05pmza.cloudfront.net/2d059152-63c2-48e9-ba79-1e7795691be8.png?_jwt=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJrZXlIYXNoIjoiMDc2OWRmYjQyNGYxYWU1YSIsImJ1Y2tldCI6InJ1bndheS10YXNrLWFydGlmYWN0cyIsInN0YWdlIjoicHJvZCIsImV4cCI6MTc0OTI1NDQwMH0.Ascj2UOqfkcZ_-LiBzrDY_JB2KYaog0mP9LgKT3crlU'
      },
      {
        id: 'scene 5-shot-2',
        key: 'shot 9',
        title: "The Key's Promise",
        location: 'Exterior - Edge of the woods',
        scenery:
          'The sun dips below the horizon, the sky a tapestry of purples and oranges. The air hums with a magical energy.',
        shot_direction:
          'The Lila stands at the edge of the woods, the key warm against her chest. She gazes into the distance, a soft smile playing on her lips, eyes filled with new determination.',
        dialogue: {
          __character1__: "One day, I'll find my way back."
        },
        characters: ['character1'],
        isGenerating: false,
        progress: 100,
        prompt:
          'The Lila stands at the edge of the woods, the key warm against her chest. She gazes into the distance, a soft smile playing on her lips, eyes filled with new determination.',
        imageSrc:
          'https://dnznrvs05pmza.cloudfront.net/c0abe28b-4ae3-44b9-b59e-719af03140cc.png?_jwt=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJrZXlIYXNoIjoiNzViMDcwMGYxZGJkNGVmOSIsImJ1Y2tldCI6InJ1bndheS10YXNrLWFydGlmYWN0cyIsInN0YWdlIjoicHJvZCIsImV4cCI6MTc0OTI1NDQwMH0.gcBdclLDshO77_8Gep0bu0ndfeiYSXVAdSFrrGKKnHs'
      }
    ]
  }
]

export const transitions = [
  {
    id: 'pan_blur',
    name: 'Pan Blur',
    icon: 'swap-right',
    effect_type: 'pan_blur',
    duration: 1.0,
    direction: 'left' // options: 'left', 'right', 'up', 'down'
  },
  {
    id: 'slide_in',
    name: 'Slide In',
    icon: 'arrow-right',
    effect_type: 'slide_in',
    duration: 1.0,
    side: 'left' // options: 'left', 'right', 'top', 'bottom'
  },
  {
    id: 'cross_desolve',
    name: 'Cross Dissolve',
    icon: 'swap',
    effect_type: 'cross_desolve',
    duration: 1.0
  },
  {
    id: 'fade_to_color',
    name: 'Fade to Color',
    icon: 'bg-colors',
    effect_type: 'fade_to_color',
    duration: 1.0,
    color: [0, 0, 0] // RGB format
  },
  {
    id: 'glitch_cut',
    name: 'Glitch Cut',
    icon: 'bug',
    effect_type: 'glitch_cut',
    duration: 0.5,
    intensity: 1.0,
    rgb_shift: true
  },
  {
    id: 'pixelate_fade',
    name: 'Pixelate Fade',
    icon: 'appstore',
    effect_type: 'pixelate_fade',
    duration: 1.0,
    max_block_size: 40
  }
]
